module.exports = __webpack_public_path__ + "images/request-job.png";